const riot = require('riot');
import './customer.tag';
import ObjectId from 'bson-objectid';
riot.tag2('customers', '<div class="level"> <div class="level-left"> <div class="level-item" style="display:block"> <h1 class="title is-5">Customers overview</h1> </div> </div> <div class="level-right"> <form onsubmit="{setSearchFilter(null,0)}" class="level-item"> <div class="field is-grouped is-flexwrap"> <div class="control"> <div class="select is-small"> <select name="targeting" ref="targeting" onchange="{setTargetingFilter}"> <option value="">Ad targeting</option> <option each="{m in targeting_options}" selected="{filter.targeting==m._id}" riot-value="{m._id}">{m.name}</option> </select> </div> </div> <div class="control"> <div class="select is-small"> <select name="market" ref="market" onchange="{setMarketFilter()}"> <option value="">Select market</option> <option each="{m in market_options}" selected="{filter.market==m._id}" riot-value="{m._id}">{m.name}</option> </select> </div> </div> <div class="control has-icons-right" style="flex-shrink:1"> <input class="input is-info {is-warning:search_active} is-small" ref="new_name" oninput="{setSearchFilter(null,500)}" type="text" placeholder="Enter/Search customer" riot-value="{filter.$or ? filter.$or[0].name.$regex : \'\'}"> <span class="icon is-small is-right" onclick="{clearSearch}" style="cursor:pointer;pointer-events:all"> <i class="fas {fa-times:!search_active,fa-spin:search_active,fa-spinner:search_active}"></i> </span> </div> <div class="control"> <span class="button is-info is-small" onclick="{createCustomer}">Add <span class="is-hidden-mobile">Customer</span></span> </div> </div> </form> </div> </div> <nav class="buttons has-addons" style="justify-content:center"> <button class="button is-small" each="{letter in abc}" onclick="{setSearchFilter(\'^\'+letter,0)}">{letter}</button> </nav> <virtual data-is="customer" each="{customers}"></virtual> <div class="level mt-3"> <div class="level-left"> <div class="level-item"> <button if="{!end_of_line}" class="button is-small is-info" onclick="{loadMore}">Load more</button> </div> </div> </div>', '', '', function(opts) {

  var self = this,
      cid = opts.id

  self.abc = 'abcčdefghijklmnoprqsštvuvxyzž'

  var filters = api.get('filters')
  filters['customers'] = filters['customers'] || {$sort:{name:1},$limit:30}
  self.filter = filters['customers']

  self.market_options = api.get('markets')

  this.setMarketFilter = function(setVal) {
    return function(e) {
      e.preventDefault()
      var val = setVal || self.refs.market.value
      if (val) {
        self.refs.market.value = self.filter.market = val
      } else delete self.filter.market;
      e.preventUpdate = true
      loadCustomers()
    }
  }.bind(this)

  self.targeting_options = [
    {_id:'on',name:'WITH targeting'},
    {_id:'off',name:'NO targeting'}
  ]
  this.setTargetingFilter = function(e) {
    e.preventDefault()
    var val = self.refs.targeting.value
    if (val) self.filter.hasTargeting = val=='on'
    else delete self.filter.hasTargeting;
    e.preventUpdate = true
    loadCustomers()
  }.bind(this)

  var search_tmout = false
  function setSearch(str,delay) {

    if (str) {
      self.filter.$or = [
        {name : {
          $regex: str,
          $options: 'i'
        }},
        {customer_id : {
          $regex: str,
          $options: 'i'
        }}
      ]
    } else delete self.filter.$or
    if (search_tmout) clearTimeout(search_tmout)
    search_tmout = setTimeout(loadCustomers,delay)
  }
  this.setSearchFilter = function(val,delay) {
    return function(e) {
      e.preventDefault()
      val = val || self.refs.new_name.value
      self.refs.new_name.value = val
      setSearch(val,delay)

    }
  }.bind(this)
  this.clearSearch = function(e) {
    e.preventDefault()
    self.refs.new_name.value = ''
    setSearch('')
    e.preventUpdate = true
  }.bind(this)

  self.editing = false
  self.customers = [];

  self.on('mount',() => {
    loadCustomers()
  })

  let last_id = false
  function loadCustomers(append=false) {
    self.search_active = true;
    self.update()

	  var filter = Object.assign({},self.filter)
	  if (append && last_id) filter.name = Object.assign({},filter.name,{$gt: last_id})

    api.service('customers')
    .find({query:filter})
		.then(r => {
      if (append && r.data.length>0) {
        self.customers = self.customers.concat(r.data)
      } else {
        self.customers = r.data
      }
      last_id = r.data.length && r.data[r.data.length-1].name || false
      self.end_of_line = r.data.length < filter.$limit
			self.search_active = false;
			self.update();
		})
		.catch(err => api.emit('toast', { type:'danger', title:'Error fetching customers', content:err.message }));
		self.update()
  }

  this.createCustomer = function(e) {
    e.preventDefault()
    let name = self.refs.new_name.value,
        user = api.get('user'),
        market = self.refs.market.value

    if (!name) return api.emit('toast',{type:'danger',title:'Name cannot be emtpy'})
    if (!market) return api.emit('toast',{type:'danger',title:'Select market first'})

    var customer_id = ObjectId()
    api.service('customers')
    .create({
      _id: {_oid:customer_id},
      customer_id: customer_id,
      name: name,
      owner: user._id,
      market
    })
    .then(customer => {
      self.refs.new_name.value = ''
      self.customers.unshift(customer)
      self.editing = customer._id
      self.update()
      api.emit('toast',{type:'info',title:'Customer created'})
    })
    .catch(e => {
      api.emit('toast',{type:'danger',title:'Error creating customer',content:e.message})
      console.log('error creating customer',e)
    })
  }.bind(this)

  this.loadMore = function(e) {
    e.preventDefault()
    e.preventUpdate = true
    loadCustomers(true)
  }.bind(this)

});

